import React from 'react';
import Text from '../../../../../Components/Base/Text/Text';
import styles from './CSSZSickLeaveCertificateFormPartA.module.scss';
import CSSZSickLeaveCertificateFormHeadline from './CSSZSickLeaveCertificateFormHeadline';
import FormattedMomentDate, {
	DateFormat,
} from '../../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import { getMomentDate } from '../../../../../Utils/dates.util';
import { CSSZUser } from '../../../Interfaces/CSSZ.interface';

interface Props {
	user: CSSZUser;
}

const CSSZSickLeaveCertificateFormPartA: React.FC<Props> = ({ user }) => {
	if (user.profile) {
		return (
			<>
				<CSSZSickLeaveCertificateFormHeadline title='component.CSSZSickLeaveCertificateFormPartA.title' />
				<div className={styles.wrapper}>
					<Text tx={user.profile.fullName} className={styles.name} />
					<div className='row'>
						<div className='col-6'>
							<div className={styles.item}>
								<Text
									tx='component.CSSZSickLeaveCertificateFormPartA.birthDate'
									inline
									colon
								/>{' '}
								<FormattedMomentDate
									date={getMomentDate(user.profile.birthDate)}
									format={DateFormat.DATE}
								/>
							</div>
						</div>
						<div className='col-6'>
							<div className={styles.item}>
								<Text
									tx='component.CSSZSickLeaveCertificateFormPartA.birthNumber'
									inline
									colon
								/>{' '}
								{user.profile.formattedBirthNumber}
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}

	return <></>;
};

export default CSSZSickLeaveCertificateFormPartA;
